import React, { Component } from 'react';
import LeftMenu from './LeftMenu'
import RightMenu from './RightMenu'
import { Drawer, Button } from 'antd';

import Logo from '../../common/images/logo.png';

class Navbar extends Component {
	constructor(props) {
		super(props);

		this.state = {
			current: 'mail',
			visible: false
		}

		// bind place
		this.showDrawer = this.showDrawer.bind(this)
		this.onClose = this.onClose.bind(this)

		this.handleLang = this.handleLang.bind(this)

	}

	showDrawer = () => {
		this.setState({
			visible: true,
		});
	};

	onClose = () => {
		this.setState({
			visible: false,
		});
	};

	handleLang = () => {
		this.props.handleLang()
	}

	render() {
		return (
			<nav className="menuBar">
				<div className="logo">
					<a href='/' style={{padding: '0px'}}><img src={Logo} style={{maxHeight: '60px', maxWidth: '140px'}}/></a>
				</div>
				<div className="menuCon">
					<div className="leftMenu">
						<LeftMenu />
					</div>
					<div className="rightMenu">
						<RightMenu
							handleLang={this.handleLang}
						/>
					</div>
					<Button className="barsMenu" type="primary" onClick={this.showDrawer}>
						<span className="barsBtn"></span>
					</Button>
					<Drawer
						title="Menu"
						placement="right"
						closable={false}
						onClose={this.onClose}
						visible={this.state.visible}
					>
						<LeftMenu type={true} />
						<RightMenu
							type={true}
							handleLang={this.handleLang}
						/>
					</Drawer>

				</div>
			</nav>
		);
	}
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js